import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { dashboard as DashboardApi } from "@teem/constants/api";

@Injectable({
	providedIn: 'root'
})
export class DashboardService {

	constructor(
		private httpClient: HttpClient
	) { }

	public getpendingSteps() {
		return this.httpClient.get(`${DashboardApi.pendingSteps}`)
	}

	public getDashboardBlockData(payload) {
		return this.httpClient.post(`${DashboardApi.dashboardBlockData}`, payload)
	}

	public getTopCustomers() {
		return this.httpClient.get(`${DashboardApi.topCustomers}`)
	}

	public getTopProducts() {
		return this.httpClient.get(`${DashboardApi.topProducts}`)
	}	

	public getRecentProducts() {
		return this.httpClient.get(`${DashboardApi.recentProducts}`)
	}

	public getCurrentOrders(payload) {
		return this.httpClient.post(`${DashboardApi.currentOrders}`, payload)
	}
	public getHistoryOrders(payload) {
		return this.httpClient.post(`${DashboardApi.historyOrders}`, payload)
	}

	public getPendingInvoice() {
		return this.httpClient.get(`${DashboardApi.pendingInvoice}`)
	}

	public getPaymentHistory() {
		return this.httpClient.get(`${DashboardApi.paymentHistory}`)
	}

	public skipCardData(payload) {
		return this.httpClient.post(`${DashboardApi.skipCard}`, payload)
	}
}
